import { AssetManager } from 'components/sharpr/assetManager/AssetManager';
import { ApiResourcify } from 'components/sharpr/api/ApiResourcify';
import { spliceOut } from 'components/sharpr/util/spliceOut';

export function FileStatusRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.FileStatus', {
		url: '/file/status',
		controllerAs: 'vm',
		controller: FileStatusCtrl,
		templateUrl: '/ng/hub/File/Status/FileStatusCtrl.html',
		resolve: {
			style: () => AssetManager.css('/ng/hub/File/Status/FileStatusCtrl.css'),
			$title: () => 'File Status',
			report: (Identity, Api, $stateParams, $location, __identityMe, __identityPermissions) => {
				'ngInject';
				if (!Identity.isSuperadmin()) {
					return Promise.resolve([]);
				}

				//check for postId query param (happens when we iframe in from react)
				const queryParams = $location.search();
				const postId = queryParams.postId ? queryParams.postId : $stateParams.postId;

				return Api.get(`/v3/posts/${postId}/attachments`).then(details => {
					const ids = details.map(att => att.id).join(',');
					return Api.get('/files/report', { ids });
				});
			},
		},
	});
}

export class FileStatusCtrl {
	constructor($stateParams, Api, modal, report) {
		'ngInject';
		this.postId = $stateParams.postId;
		this.Api = Api;
		this.modal = modal;
		this.report = report;
	}

	reprocess(file) {
		this.Api.post(`/files/${file.id}/reprocess`);
		file.isReprocessing = true;
	}

	unlink(file) {
		this.modal.confirm({ text: 'Are you sure you want to remove this file from the post?' }).then(
			() => {
				this.Api.delete(`/posts/${this.postId}/attachments/${file.id}`);
				spliceOut(this.report, file);
			},
			() => {}
		);
	}
}
